import styled from "styled-components";
import { Button } from "../../../styles/button";

const ModalButton = styled(Button)`
  color: #0b233f;
  border-color: #283678;
  border-radius: 2px;
  height: 40px;
  width: 275px;
  display: inline-block;
  @media (max-width: 420px) {
    width: 150px;
  }
`;

export const InterestedButton = styled(ModalButton)`
  background-color: #bbdfe4;
  margin: 0px 30px 0px 30px;
  @media (max-width: 420px) {
    margin: unset;
  }
`;

export const PassButton = styled(ModalButton)`
  background-color: #ff8f80;
`;

export const Content = styled.div`
  height: 75%;
  width: 100%;
  padding: 32px;
  overflow-y: auto;
  &:first-child {
    border-right: solid 3px rgba(185, 185, 196, 0.17);
  }
  @media (max-width: 420px) {
    padding: 24px 30px;
  }
`;

export const H1 = styled.h1`
  letter-spacing: 1px;
  font-family: Lato;
  color: white;
  border: none;
  font-size: 32px;
`;

export const Statement = styled.p`
  letter-spacing: 1px;
  font-family: Lato;
  color: #666;
  font-size: 16px;
  text-align: left;
  line-height: normal;
  @media (max-width: 420px) {
    font-size: 14px;
  }
`;

export const ModalTitle = styled(H1)`
  color: #666;
  border: none;
  font-size: 32px;
  margin-left: 20px;
`;

export const H3 = styled.h3`
  letter-spacing: 1.6px;
  font-family: Lato;
  color: #283678;
  border: none;
  font-size: 20px;
`;

export const H4 = styled.h3`
  letter-spacing: 1.6px;
  font-family: Lato;
  color: black;
  border: none;
  font-size: 15px;
`;

export const H5 = styled.h3`
  letter-spacing: 1.6px;
  font-family: Lato;
  color: #283678;
  border: none;
  font-size: 13px;
  margin-top: 5px;
`;



// WEBPACK FOOTER //
// ./src/components/Modals/Company/CompanyModal.styles.js